exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.announcement-modal{background-image:url(" + require("../../../assets/images/geometric-sidebar-blue.png") + ");background-size:cover;color:#184e78;display:flex;flex-direction:column;height:100%;width:100%;z-index:9999}.announcement-modal__x{color:#fff;cursor:pointer;float:right;margin:3px 16px 0 auto;font-size:29px}.announcement-modal__heading,.announcement-modal__subheading{font-family:Oswald,sans-serif;margin-left:16px}.announcement-modal__heading{font-size:40px;font-weight:300;height:60px;margin-left:16px;margin-top:calc(25.2% - 34px);margin-bottom:0;text-transform:uppercase}.announcement-modal__subheading{font-size:48px;font-weight:400;height:71px;margin:0 0 0 16px;overflow:visible;white-space:nowrap}.announcement-modal__body{font-family:Open Sans,sans-serif;font-size:22px;font-weight:300;margin-left:32px;margin-right:16px;margin-bottom:50px}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/modals/AnnouncementModal/AnnouncementModal.scss
// module id = 1698
// module chunks = 0